import { Tag, TagSize } from "@cofano/cck";
import { CharterSubtype } from "__generated__/enums";
import { intl } from "LocaleWrapper";
import React from "react";
import { getCharterSubtypeColor } from "view/charters/utils/CharterUtils";

type CharterSubtypeTagProps = {
	type?: CharterSubtype | null,
	customText?: string,
}

const CharterSubtypeTag = ({ type, customText }: CharterSubtypeTagProps) => {

	const getText = () => {
		switch (type) {
			case CharterSubtype.Spot:
				return intl.formatMessage({ id: "SPOT" });
			case CharterSubtype.Time:
				return intl.formatMessage({ id: "TIME" });
			case CharterSubtype.Contract:
				return intl.formatMessage({ id: "CONTRACT" });
			case CharterSubtype.Supplier:
				return intl.formatMessage({ id: "SUPPLIER" });
		}
	};

	if (type) {
		return (
			<Tag
				color={getCharterSubtypeColor(type)}
				text={customText || getText() || type}
				size={TagSize.NORMAL} />
		);
	} else {
		return <React.Fragment />;
	}
};

export default CharterSubtypeTag;
